import React from 'react';
import { Button } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { Intl } from 'components';

export default React.memo( ( {
  cancelTo, onClickCancel, marginContainer = true, centerButtons = true,
  saveLabel = 'okBtn', translateSaveBtn = true,
} ) => (
  <div className={classnames( {
    'mt-4': marginContainer,
    'text-center': centerButtons,
  } )}
  >
    <Button
      color="app-default"
      size="app-sm"
      className="font-weight-700 mr-2"
    >
      {translateSaveBtn ? <Intl id={saveLabel} /> : saveLabel}
    </Button>

    {cancelTo
      ? (
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
          tag={Link}
          to={cancelTo}
        >
          <Intl id="cancel" />
        </Button>
      ) : null}

    {onClickCancel && !cancelTo
      ? (
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
          onClick={onClickCancel}
        >
          <Intl id="cancel" />
        </Button>
      ) : null}
  </div>
) );
